module.exports = __webpack_public_path__ + "img/user-profile-blue.d673e2e6.png";